import React from 'react';
import Page from '../components/Page';
import {
  Card,
  CardBody,
  Modal,
  Row, Col
} from 'reactstrap';
import { MdDone, MdClear, MdCheck, MdClose } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import axios from 'axios';
import moment from 'moment-timezone';
import StorageService from '../services/StorageService';
import PosLicensingTable from '../components/PosLicensingTable';
import PosLicensingForm from '../components/PosLicensingForm';
import TableActionButton from '../components/TableActionButton';
import { TextWidget } from '../components/Widget'
//import { datatype } from 'faker';
import Switch from "react-switch";

class PosLicensingPage extends React.Component {
  state = {
    list: [],
    list2: [],
    isEdit: false,
    modal: false,
    editItem: null,
    show_disabled: false,
    show_list: [],
    enabled_count: 0,
    disabled_count: 0,
    
  };

  toggle = (action, id) => () => {
    let obj = null;

    if (id !== undefined || id !== null) {
      obj = this.state.show_list.find(e => e.company_id === id);
    }

    return this.setState({
      modal: !this.state.modal,
      isEdit: action === 'ADD' ? false : true,
      editItem: obj
    });
  };

  toggleDisabledRow = (e) => {
    this.setState({ show_disabled: !this.state.show_disabled}, () => this.custData(this.state.list));
  };

  thousands(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  custData(data) {
    const { list2, show_disabled } = this.state;
    let arr = [];
    let enabled_count = 0;
    let disabled_count = 0;

    for (let d of data) {
      let store = this.thousands(d.store_count) + '/' + this.thousands(d.store_limit);
      let product = this.thousands(d.product_count) + '/' + this.thousands(d.product_limit);
      let customer = this.thousands(d.customer_count) + '/' + this.thousands(d.customer_limit);

      let org = list2.find(el => el.CompanyID === d.company_id);
      
      if (org) {
        d.company_name = org ? org.CompanyName : '';
        d.is_disabled = d.disable > 0 ? <span className="text-danger">Yes</span> : 'No';
        d.store = d.store_count > d.store_limit ? <span className="text-danger">{store}</span> : store;
        d.product = d.product_count > d.product_limit ? <span className="text-danger">{product}</span> : product;
        d.customer = d.customer_count > d.customer_limit ? <span className="text-danger">{customer}</span> : customer;
        d.startdate = moment(d.startdate).tz('Asia/Singapore').format('YYYY-MM-DD');
        d.next_bill = moment(d.next_bill).tz('Asia/Singapore').format('YYYY-MM-DD');
        d.action = <TableActionButton
          edit={{ active: true, action: this.toggle('EDIT', d.company_id), component: null }}
          delete={{ active: false, action: '', component: null }}
          view={{ active: false, action: '', component: null }}
          custom={{ active: true, action: () => this.props.history.push({ pathname: `/licensing/${d.company_id}/billing` }), component: null }} />;

        arr.push(d);
        if(d.disable < 1)  
          enabled_count++;
        else disabled_count ++;
      }
    }

    if(!show_disabled) {
      arr = arr.filter(el => el.disable < 1);
    }

    arr.sort(function(a, b) {
      var nameA = a.billing_type.toUpperCase(); // ignore upper and lowercase
      var nameB = b.billing_type.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    });

    this.setState({
      list: data,
      show_list: arr,
      enabled_count,
      disabled_count
    });
  };

  

  updatePOSFeature = (dt) => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    console.log(dt.pos_feature)
    const data = {
      session_key: user.session_key,
      CompanyID: dt.company_id,
      ID: dt.pos_feature.Id,
      Feature: dt.pos_feature.Feature,
      Status: dt.disable > 0 ? 0 : 1,
      Order: dt.pos_feature.RowOrder,
    };

    axios
      .post(url + ':3000/v1/company/setFeature', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          alert(result.message);
          return;
        }

      })
      .catch(error => {
        alert(error);
      });
  };

  update = data => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const formData = {
      session_key: process.env.REACT_APP_UNITY_API2_KEY,
      company_id: data.company_id,
      startdate: data.startdate,
      disable: data.disable,
      billing_type: data.billing_type,
      next_bill: data.next_bill,
      billing_amt: data.billing_amt,
      payment_status: data.payment_status,
      plan: data.plan,
      store_limit: data.store_limit,
      ecart_limit: data.ecart_limit,
      product_limit: data.product_limit,
      customer_limit: data.customer_limit,
      update_by: user.email
    };

    axios
      .post(url + ':3001/v1/licensing/update', formData)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.setState({
          modal: false,
          isEdit: false,
          editItem: null
        });

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'POS Licensing updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });

        this.updatePOSFeature(data);
        this.get();
      })
      .catch(error => {
        alert(error);
      });
  };

  getCompany = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/company/getSystemCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.setState({ list2: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  get = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: process.env.REACT_APP_UNITY_API2_KEY,
    };

    axios
      .post(url + ':3001/v1/license', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (result.data.length > 0) {
          this.custData(result.data);
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getCompany();
    this.get();
  }

  render() {
    return (
      <Page
        title="POS Licensing"
        breadcrumbs={[{ name: 'POS Licensing', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Card>
          <CardBody>
            <Row>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Enabled" text={this.state.enabled_count} />
              </Col>
              <Col lg={3} md={6} sm={6} xs={12}>
                <TextWidget title="Disabled" text={this.state.disabled_count} />
              </Col>
            </Row>
            <div className="d-flex align-items-center">
              <span style={{fontSize: '0.85rem', fontWeight: '500'}}>Show Disabled</span>&nbsp;&nbsp;
              <Switch uncheckedIcon={false} checkedIcon={false} offColor="#E74C3C" onChange={this.toggleDisabledRow} checked={this.state.show_disabled} />
            </div>
            <br/>
            <div style={{fontSize: '0.85rem'}}>Note: By default, records are sorted by billing type in ascending order.</div>
            <PosLicensingTable rows={this.state.show_list} />
          </CardBody>
        </Card>

        <Modal isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          centered>
          <PosLicensingForm
            isEdit={this.state.isEdit}
            item={this.state.editItem}
            toggle={this.toggle}
            update={this.update} />
        </Modal>
      </Page>
    );
  }
}
export default PosLicensingPage;
